<template>
	<div>
		<div class="filter">
			<div class="filter-button" @click="openFilter('noType')">
				<i class="iconfont icon-funnel" style="font-size: 12px;margin-right: 4px"></i>
				<span>筛选</span>
			</div>
			<div style="width: 600px;line-height: 32px">
				<div v-for="(item,key) in selectObjDone" class="filter-button-right">
					<div v-if="item.length > 0" style="padding: 0 8px">
						<span @click="openFilter(key)">
							<div class="text-max-len-120" :title="getResultName(item,key)">{{ getResultItem(item,key) }}</div>
							<div v-show="item.length > 1" style="float: left"> + 另外{{item.length - 1}}个</div>
						</span>
						<i @click="deleteConditionItem(key)" class="iconfont icon-Cross delete-button"></i>
					</div>
				</div>
			</div>
		</div>
		<div class="filter-container" v-show="showContent">
			<div class="filter-content">
				<div class="filter-left">
					<ul class="filter-left-ul">
						<li v-for="(item,key) in typeList" @click="changeType(key)" :class="{select: typeSelect === key}" :key="key">
							{{item.title}}
						</li>
					</ul>
				</div>
				<div class="filter-middle">
					<div style="border-bottom: 1px solid rgb(220, 225, 231);">
						<Input v-model="searchWord" prefix="ios-search" placeholder="请输入关键字..." />
					</div>
					<div v-if="loading" class="filter-middle-content-loading">
						<Spin fix></Spin>
					</div>
					<div v-else>
						<div v-show="showAllCheckBox" style="margin:8px 13px;">
							<Checkbox
								:indeterminate="indeterminate"
								:value="checkAll"
								@click.prevent.native="handleCheckAll">
								<span style="margin-left: 4px">全选</span>
							</Checkbox>
						</div>
						<div v-show="typeSelect === 'partner'">
							<div class="filter-middle-content">
								<div v-if="partnerMiddleObj.length">
									<CheckboxGroup v-model="partnerSelect" @on-change="checkAllGroupChange">
										<Checkbox
											v-for="(item,index) in partnerMiddleObj"
											v-show="getSearch(item.name)"
											:label="item.id" :value="item.id" :key="index"
											class="text-max-len" style="height: 32px;line-height: 32px" >
											<span style="margin-left: 4px" :title="item.name">{{item.name}}</span>
										</Checkbox>
									</CheckboxGroup>
								</div>
								<div v-else style="text-align: center;margin-top: 60px">暂无数据</div>
							</div>
						</div>
						<div v-show="typeSelect === 'version'">
							<div class="filter-middle-content">
								<div v-if="versionMiddleObj.length">
									<CheckboxGroup v-model="versionSelect" @on-change="checkAllGroupChange">
										<Checkbox
											v-for="(item,index) in versionMiddleObj"
											v-show="getSearch(item.name)"
											:label="item.id" :value="item.id" :key="index"
											class="text-max-len" style="height: 32px;line-height: 32px" >
											<span style="margin-left: 4px" :title="item.name">{{item.name}}</span>
										</Checkbox>
									</CheckboxGroup>
								</div>
								<div v-else style="text-align: center;margin-top: 60px">暂无数据</div>
							</div>
						</div>
						<div v-show="typeSelect === 'usergroup'">
							<div class="filter-middle-content">
								<div v-if="usergroupMiddleObj.length">
									<CheckboxGroup v-model="usergroupSelect" @on-change="checkAllGroupChange">
										<Checkbox
											v-for="(item,index) in usergroupMiddleObj"
											v-show="getSearch(item.name)"
											:label="item.id" :value="item.id" :key="index"
											class="text-max-len" style="height: 32px;line-height: 32px" >
											<span style="margin-left: 4px" :title="item.name">{{item.name}}</span>
										</Checkbox>
									</CheckboxGroup>
								</div>
								<div v-else style="text-align: center;margin-top: 60px">暂无数据</div>
							</div>
						</div>
					</div>
				</div>
				<div class="filter-right">
					<div class="filter-right-header">
						已选择<span style="color: #1e93ff"> {{selectLength}} </span>个过滤条件
					</div>
					<div class="filter-right-content">
						<div v-show="partnerSelect.length" class="filter-right-content-item">
							<div class="filter-right-content-item-title">渠道</div>
							<ul class="filter-right-content-item-ul">
								<li v-for="(item,index) in partnerSelect" :key="item">
									<span class="text-max-len" :title="partnerNameMap[item]">{{partnerNameMap[item]}}</span>
									<Icon @click="deleteItemSelect('partner', index)" type="md-close"></Icon>
								</li>
							</ul>
						</div>
						<div v-show="versionSelect.length" class="filter-right-content-item">
							<div class="filter-right-content-item-title">版本</div>
							<ul class="filter-right-content-item-ul">
								<li v-for="(item,index) in versionSelect" :key="item">
									<span class="text-max-len" :title="versionNameMap[item]">{{versionNameMap[item]}}</span>
									<Icon @click="deleteItemSelect('version', index)" type="md-close"></Icon>
								</li>
							</ul>
						</div>
						<div v-show="usergroupSelect.length" class="filter-right-content-item">
							<div class="filter-right-content-item-title">用户分群</div>
							<ul class="filter-right-content-item-ul">
								<li v-for="(item,index) in usergroupSelect" :key="item">
									<span class="text-max-len" :title="usergroupNameMap[item]">{{usergroupNameMap[item]}}</span>
									<Icon @click="deleteItemSelect('usergroup', index)" type="md-close"></Icon>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="filter-footer">
				<Button @click="cancelConditions" style="margin-right: 18px;width: 80px">取消</Button>
				<Button @click="submitConditions" style="margin-right: 18px;width: 80px" type="primary">确定</Button>
			</div>
		</div>
	</div>
</template>

<script>
  import FilterService from './FilterService';
  import BaseLib from '../../base/BaseLib';
  import FilterConst from './FilterConst';
  import AnalyticsPublic from '../../base/AnalyticsPublic';

  export default {
    name: 'GlobalFilter',
    data() {
      return {
        showContent: false,
        typeSelect: 'partner',
        typeList: {},
        searchWord: '',
        selectObjDone: {
          partner: [],
          version: [],
          usergroup: [],
          newUserGroup: [],
        },// 点击确定后的值

        partnerMiddleObj: [],
        partnerSelect: [],
        partnerNameMap: {},

        versionMiddleObj: [],
        versionSelect: [],
        versionNameMap: {},

        usergroupMiddleObj: [],
        usergroupSelect: [],
        usergroupNameMap: {},

        loading: true,
        indeterminate: false,
        checkAll: false,
      }
    },
    computed: {
      selectLength() {
        return this.partnerSelect.length + this.versionSelect.length + this.usergroupSelect.length
      },
      showAllCheckBox() {
        if (this.typeSelect && this[`${this.typeSelect}MiddleObj`].length > 0) {
          return true
        } else {
          return false
        }
      },
    },
    watch: {
      searchWord() {
        const str = `${this.typeSelect}Select`;
        this.checkAllGroupChange(this[str])
      }
    },
    methods: {
      getResultItem(item, key) {
        const obj = FilterConst.filterType;
        const nameMap = this[`${key}NameMap`];
        return `${obj[key].title} = ${nameMap[item[0]]}`;
      },
      getResultName(item, key) {
        const obj = FilterConst.filterType;
        const nameMap = this[`${key}NameMap`];
        let res = [];
        item.forEach(i => {
          res.push(nameMap[i])
        });
        return `${obj[key].title} = ${res.join(',')}`;
      },
      openFilter(key) {
        if (key === 'noType') {
          this.typeSelect = Object.keys(this.typeList)[0]
        } else {
          this.typeSelect = key;
        }

        if (this.showContent) {
          return
        }
        this.showContent = true;

        // 需要同步所有(当前页面支持的)类型的已选
        Object.keys(this.typeList).forEach(item => {
          this[`${item}Select`] = BaseLib.cloneDeep(AnalyticsPublic.conditions[item]);
        });
        this.queryData(this.typeSelect);
      },
      getSearch(item) {
        if (this.searchWord) {
          return item.indexOf(this.searchWord) > -1
        } else {
          return true
        }
      },
      changeType(id) {
        this.typeSelect = id;
        this.searchWord = '';

        this.queryData(id);
      },

      handleCheckAll () {
        if (this.indeterminate) {
          this.checkAll = false;
        } else {
          this.checkAll = !this.checkAll;
        }
        this.indeterminate = false;

        if (this.checkAll) { // 全选
          this[`${this.typeSelect}MiddleObj`].forEach(item => {
            if (item.name.indexOf(this.searchWord) > -1) {
              this[`${this.typeSelect}Select`].push(item.id)
            }
          });
        } else { // 取消全选
          this[`${this.typeSelect}Select`] = [];
        }
      },
      checkAllGroupChange (data) {
        if (data.length === this[`${this.typeSelect}MiddleObj`].length) {
          this.indeterminate = false;
          this.checkAll = true;
        } else if (data.length > 0) {
          this.indeterminate = true;
          this.checkAll = false;
        } else {
          this.indeterminate = false;
          this.checkAll = false;
        }
      },

			// 在弹框中删除
      deleteItemSelect(type, index) {
        this[`${type}Select`].splice(index, 1);

        this.checkAllGroupChange(this[`${type}Select`])
      },

			// 在展示结果处删除
      deleteConditionItem(key) {
        this.showContent = false;

        AnalyticsPublic.conditions[key] = [];// 更新local
        this.selectObjDone[key] = [];// 更新展示结果

        this.$emit('gob-change-condition', AnalyticsPublic.conditions);
      },
      submitConditions() {
        this.showContent = false;

        Object.keys(AnalyticsPublic.conditions).forEach(item => {
          if (this[`${item}Select`]) {
            const list = this[`${item}Select`];
            AnalyticsPublic.conditions[item] = list;// 更新local
            this.selectObjDone[item] = list;// 更新展示结果
          }
        });

        this.$emit('gob-change-condition', AnalyticsPublic.conditions);
      },
      cancelConditions() {
        if (!this.showContent) return;
        this.showContent = false;
      },

      queryData(id, callback) {
        this.loading = true;
        this[`${id}MiddleObj`] = [];
        FilterService.queryDict(id, (res) => {
          this.loading = false;
          const tmp = [];
          Object.keys(res).forEach(item => {
            this[`${id}NameMap`] = res;
            tmp.push(
              {
                id: item,
                name: res[item],
              },
            );
          });
          this[`${id}MiddleObj`] = tmp;
          if (callback) {// 初始化时渲染结果展示行
            callback();
          } else {
            this.checkAllGroupChange(this[`${id}Select`]);
          }
        })
      },
      getTypeList() {
        const routerName = this.$route.name;
        const filterType = BaseLib.cloneDeep(FilterConst.filterType);

        const noVersion = FilterConst.noVersion;
        const noPartner = FilterConst.noPartner;
        const haveUserGroup = FilterConst.haveUserGroup;

        if (noPartner.indexOf(routerName) > -1) {
          delete filterType['partner'];
        }
        if (noVersion.indexOf(routerName) > -1) {
          delete filterType['version'];
        }
        if (haveUserGroup.indexOf(routerName) === -1) {
          delete filterType['usergroup']
        }

        this.typeList = filterType;
        this.typeSelect = this.typeList.length > 0 ? Object.keys(this.typeList)[0] : '';
      },
      renderResult() {
        const localConditions = AnalyticsPublic.conditions;

        Object.keys(localConditions).forEach(item => {
          // 当前页面支持此类型筛选时
          if (this.typeList[item]) {
            if (localConditions[item].length > 0){
              this.queryData(item, () => {
                this.selectObjDone[item] = localConditions[item];
              });
            }
          }
        })
      },

      clearSelect() {
        this.selectObjDone = BaseLib.cloneDeep(AnalyticsPublic.conditions);
        this.showContent = false;
      },
    },
    mounted() {
      this.getTypeList();
			this.renderResult();
    }
  };
</script>

<style scoped>
.filter{
	display: flex;
}
.filter-button{
	cursor: pointer;
	margin-left: 16px;
	line-height: 32px;
	font-size: 14px;
	width: 50px;
}
.filter-button-right{
	margin-right: 8px;
	font-size: 13px;
	color: #1890FF;
	background: rgba(230, 247, 255, 1);
	font-weight: 500;
	display: inline-block;
}
.delete-button{
	background: #1890FF;
	color: white;
	cursor: pointer;
	margin-left: 4px;
}
.filter-container{
	width: 756px;
	background: white;
	height: 334px;
	border: 1px solid rgb(220, 225, 231);
	position: absolute;
	left: 0px;
	top: 56px;
	font-size: 14px;
}
.filter-content{
	height: 84%;
	border-bottom: 1px solid rgb(220, 225, 231);
}

.filter-left{
	width: 13%;
	height: 100%;
	float: left;
	border-right: 1px solid rgb(220, 225, 231);
}
.filter-left-ul{
	list-style: none;
}
.filter-left-ul li{
	line-height: 40px;
	padding-left: 6px;
	font-size: 14px;
	border-bottom: 1px solid rgb(220, 225, 231);
}
.filter-left-ul li.select{
	color: #5cadff;
	background: rgba(242, 242, 242, 1);
}
.filter-left-ul li:hover{
	color: #5cadff;
}

.filter-middle{
	width: 62%;
	height: 100%;
	float: left;
	border-right: 1px solid rgb(220, 225, 231);
}
.filter-middle-content{
	height: 200px;
	padding: 0 12px;
	overflow-y: scroll;
}
.filter-middle-content-loading{
	display: inline-block;
	width: 100%;
	height: 80%;
	position: relative;
}

/deep/ .ivu-input{
	height: 40px;
	border:none;
	border-radius: revert;
}
/deep/ .ivu-input:focus {
	box-shadow: none;
}

.filter-right{
	width: 25%;
	height: 100%;
	float: left;
}
.filter-right-header{
	line-height: 40px;
	border-bottom: 1px solid rgb(220, 225, 231);
	padding-left: 6px;
}
.filter-right-content{
	overflow-y: scroll;
	height: 226px;
	padding: 8px;
}
.filter-right-content-item{
	margin-bottom: 12px;
}
.filter-right-content-item-ul li{
	height: 32px;
	line-height: 32px;
	list-style: none;
	font-weight: 400;
	color: #515B6F;
}
.filter-right-content-item-ul li:hover{
	color: #5cadff;
}
.filter-right-content-item-ul li .ivu-icon{
	float: right;
	line-height: 32px;
}
.filter-right-content-item-title{
	font-weight: 600;
	color: #17233D;
}
/deep/ .ivu-checkbox-wrapper{
	font-size: 14px;
}
.text-max-len {
	width: 136px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: inline-block;
}
.text-max-len-120 {
	max-width: 120px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	float: left;
}
.filter-footer{
	line-height: 54px;
	float: right;
}
</style>
